import React from "react";
import "./Home.css";
import Product from "./componenets/Product";

function Home() {
    return(
        <div className="home">
            <div className="home_container">
                <img 
                    className="home_image"
                    src="https://m.media-amazon.com/images/I/61gAmU0k7jL._SX3000_.jpg"
                    alt=""
                /> 
                <div className="home_row">
                    <Product 
                        id='1'
                        title="وحدة تحكم بلاي ستيشن 5 اصدار رقمي رفيع  "
                        price={1699.99}
                        image="https://m.media-amazon.com/images/I/31NIiT7QknL._AC_SL1000_.jpg"
                        rating={5}
                    />
                    <Product 
                        id='2'
                        title="جيوردانو طقم شنط سفر 5 قطع تي اس ايه (PC)"
                        price={734.900}
                        image="https://m.media-amazon.com/images/I/615+UZ248pL._AC_SY300_SX300_.jpg"
                        rating={4}
                    />
                    <Product 
                        id='3'
                        title="ساعة يد انيقة للرجال من بينيار بسوار من السيليكون"
                        price={6.550}
                        image="https://m.media-amazon.com/images/I/71sCZqG5NtL._AC_SX679_.jpg"
                        rating={3}
                    />
                </div>  
                <div className="home_row">
                    <Product 
                        id='4'
                        title="بايريدو انفلوريسنس او دي بارفان للنساء 100 مل
"
                        price={1089.000}
                        image="https://m.media-amazon.com/images/I/61TXxCwJljL._AC_SX679_.jpg"
                        rating={2}
                    />
                    <Product 
                        id='5'
                        title="نظارة شمسية كاناستال بعدسات مستقطبة"
                        price={394.000}
                        image="https://m.media-amazon.com/images/I/71sd9O9g9hL._AC_SX679_.jpg"
                        rating={5}
                    />
                </div>  
                <div className="home_row">
                    <Product 
                        id='6'
                        title="شاشة الألعاب ليد المنحنية مقاس 49 بوصة من سامسونج = فائقة الاتساع"
                        price={1094.98}
                        image="https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg"
                        rating={5}
                    />
                </div> 
            </div>
        </div>
        
    )
}

export default Home;